
import React from 'react'
import {connect} from "react-redux";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import {
    BOTONERA_ACCION_NUEVO,
    BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import {
    COMPONENTE_TIPO_COLOR, COMPONENTE_TIPO_INPUT,
    renderFormulario, renderGrid
} from "../utils/FormularioUtils";
import Titulo from "../../framework2/ej2/UI/Titulo";
import {loadDatos} from "../utils/FormularioUtils";
import Doctor from "./Doctor";

class Doctores extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),
        }

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                }
            },
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:200},
            {campo:"color", titulo: "Color", tipo: CELLTIPO_COLOR, ancho:70, editable: true},
        ];

        this.elementoConfig= {
            className: "Doctor",
            secciones: [
                {
                    titulo: "Datos ",
                    campos: [
                        {campo: "nombre", titulo: "Nombre", tipo: COMPONENTE_TIPO_INPUT, cols: 4, obligatorio: true},
                        {campo: "color", titulo: "Color", tipo: COMPONENTE_TIPO_COLOR, cols: 1},
                    ]
                },
            ]
        };

    }

    componentDidMount() {
        this.loadDatos();
    }

    loadDatos= () =>{
        loadDatos(this, "Doctor");
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
            default:
                break;
        }
    }

    nuevoElemento= () => {
        const{estado, paciente} = this.props;

        let elemento= {
            color: "#ffffff",
        } ;

        console.log("Nuevo Elemento");
        this.setState({elementoSeleccionado: elemento, showGrid: false});
    }

    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }

    render() {
        const {showGrid, datos} = this.state;
        let propiedades={height: 400};
        return (
            <div style={{margin: 8, padding: 4}}>
                {<Titulo titulo="Gestión de Doctores" soloTitulo={true} onNuevo={this.nuevoElemento}/> }
                {Boolean(showGrid) && renderGrid(this, "Doctores", datos, this.onAccion, propiedades) }
                {!Boolean(showGrid) && renderFormulario(this, <Doctor/>)}
            </div>
        )
    }

}

Doctores.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Doctores);



